import {SignupRequest} from "../models/signup-request.model";
import {CompanyData} from "../models/company-data.model";
import {FisicaVerficacionDatosModel} from '../models/fisica-verficacion-datos.model';
import {UserDocumentTypeListRequest} from '../models/user-document-type-list-request';

export class SignupAction {
  static readonly type = '[Account] SignupAction';
  constructor(public payload: SignupRequest) {}
}
export class RecoverPasswordAction {
  static readonly type = '[Account] RecoverPasswordAction';
  constructor(public payload: { email:string }) {}
}
export class ResetPasswordAction {
  static readonly type = '[Account] ResetPasswordAction';
  constructor(public payload:{
    code: string,
    password: string,
    token: string
  }) {}
}

export class ChangePasswordAction {
  static readonly type = '[Account] ChangePasswordAction';
  constructor(public payload:{
    newPassword: string,
    currentPassword: string,
  }) {}
}

export class UpdateIdentityVerificationStatus {
  static readonly type = '[Account] UpdateIdentityVerificationStatus';
  constructor(public payload: {identityDetail: any}) {}
}

export class VerifyInformationAction {
  static readonly type = '[Account] VerifyInformationAction';
  constructor(public payload: { userDocumentTypeList: UserDocumentTypeListRequest }) {
  }
}
export class VerifyFisicaInformationAction {
  static readonly type = '[Account] VerifyFisicaInformationAction';
  constructor(public payload: { userDocumentTypeList: UserDocumentTypeListRequest }) {
  }
}

export class GetAccountStatusAction {
  static readonly type = '[Account] GetAccountStatusAction';
  constructor() {}
}
export class GetAccountPersonalDataAction {
  static readonly type = '[Account] GetAccountPersonalDataAction';
  constructor() {}
}

export class UpdateKycInformacionAdicionalFisicaAction {
  static readonly type = '[Account] UpdateKycInformacionAdicionalFisicaAction';
  constructor(public payload:{additionalInformation:any}) {}
}
export class UpdateKycInformacionAdicionalJuridicaAction {
  static readonly type = '[Account] UpdateKycInformacionAdicionalJuridicaAction';
  constructor(public payload:{additionalInformation:any}) {}
}
export class RequestInvestorProfileAction {
  static readonly type = '[Account] RequestInvestorProfileAction';
  constructor() {}
}
export class RequestInvestorContractDocumentAction {
  static readonly type = '[Account] RequestInvestorContractDocumentAction';
  constructor() {}
}
